import LetMeMap from 'LetMeMap';
import HotelDetailsWidget from './HotelDetailsWidget';
import DestinationResultsDate from './DestinationResultsDate';
import DestinationsTreeWidget from './DestinationsTreeWidget';
import {
	HOTEL_DETAILS,
	RESULTS_DESTINATION,
	DESTINATIONS_TREE
} from '../globals/widgetTypes';

export default class MeliaLetMeMap extends LetMeMap {
	constructor() {
		super(true);
	}

	createWidget(containerId, config, api) {
		this._chooseWidget(config);
		return super.createWidget(containerId, config, api);
	}

	_chooseWidget(config) {
		if (config.typeWidget === HOTEL_DETAILS) {
			this.widgetClass = HotelDetailsWidget;
		} else if (config.typeWidget === RESULTS_DESTINATION) {
			this.widgetClass = DestinationResultsDate;
		} else if (config.typeWidget === DESTINATIONS_TREE) {
			this.widgetClass = DestinationsTreeWidget;
		} else {
			throw new Error('LetMeMap::createWidget: typeWidget wrong');
		}
	}
}



// WEBPACK FOOTER //
// ./src/widget/MeliaLetMeMap.js